/**
 * Reader for the `initData` blob that AppPropertiesProvider caches in
 * localStorage from the legacy Java `rest/mobile/iteach/sync/init` endpoint.
 *
 * That fetch is best-effort: its catch only logs, so `initData` is simply absent
 * whenever the Java backend is unreachable — permanently so on tenants that have
 * no Java backend at all (see Config.hasJavaBackend). Callers used to do a bare
 * `JSON.parse(localStorage.getItem("initData"))`, which yields `null` and then
 * throws a TypeError on the first field access. In a render() that took down the
 * whole React root, because iteach has no error boundary — a blank white page.
 *
 * Always go through this helper so a missing/corrupt blob degrades to defaults
 * instead of crashing the page.
 */
export interface AttendanceConfig {
  batchDisplayName: string;
  topicDisplayName: string;
  allowLessonplanWithoutAttendance?: boolean;
  [key: string]: any;
}

const DEFAULTS: AttendanceConfig = {
  batchDisplayName: "Batch",
  topicDisplayName: "Topic",
};

export function getAttendanceConfig(): AttendanceConfig {
  let parsed: any = null;
  try {
    // Note: the raw value can also be the literal string "undefined" when a
    // non-JSON response (e.g. an SPA index.html fallback) was stringified in.
    parsed = JSON.parse(localStorage.getItem("initData") || "null");
  } catch {
    parsed = null;
  }
  return parsed && typeof parsed === "object"
    ? { ...DEFAULTS, ...parsed }
    : { ...DEFAULTS };
}

export default getAttendanceConfig;
